export default product => ['A7H3WJZ5F9'].indexOf(product.code) === -1;



// WEBPACK FOOTER //
// ./src/utils/isProductAvailableInUSCanada.js